<!--
  ~ Copyright (c) Worldline 2022.
  -->

<!DOCTYPE html>

<div class="content">
    <fieldset>
        <legend id="signature-frame-legend">{{ 'signature.text' | translate }}</legend>
        <div id="signatureFrame">
            <div id="signatureSource">
                <canvas></canvas>
            </div>


        </div>
        <div>
            <a id="erase-signature-frame" (click)="clear()" class="k-button k-reset floatNone">{{
                'signature.erase' | translate }}</a>
        </div>
        <br/>
    </fieldset>
</div>


